<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-data-filter`]" width="1em" height="1em" v-bind="$attrs"><path d="M10.2793 11.8955C10.6464 11.8956 10.9442 12.1934 10.9443 12.5605C10.9443 12.9278 10.6465 13.2255 10.2793 13.2256H5.72266C5.35545 13.2255 5.05762 12.9278 5.05762 12.5605C5.05775 12.1934 5.35553 11.8956 5.72266 11.8955H10.2793ZM12.5547 7.33789C12.9217 7.33813 13.2196 7.63593 13.2197 8.00293C13.2197 8.37005 12.9217 8.66772 12.5547 8.66797H3.44141C3.07414 8.66797 2.77637 8.3702 2.77637 8.00293C2.7765 7.63578 3.07422 7.33789 3.44141 7.33789H12.5547ZM14.835 2.78125C15.2021 2.78143 15.5 3.07913 15.5 3.44629C15.4997 3.81324 15.2019 4.11115 14.835 4.11133H1.16504C0.797991 4.11125 0.500251 3.8133 0.5 3.44629C0.5 3.07907 0.797837 2.78133 1.16504 2.78125H14.835Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineDataFilter',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
